"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { motion } from "framer-motion";
import MobileMenu from "./MobileMenu";

export default function Header() {
  const pathname = usePathname();
  const navItems = [
    { label: "Home", href: "/" },
    { label: "Services", href: "/services" },
    { label: "Portfolio", href: "/portfolio" },
    { label: "Market", href: "/market" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <header className="fixed top-0 w-full z-50 bg-surface/80 dark:bg-surface/80 backdrop-blur-md border-b border-outline-variant dark:border-outline animate-in fade-in duration-500">
      <div className="flex justify-between items-center px-margin-mobile md:px-margin-desktop py-4 max-w-[1440px] mx-auto">
        <Link className="font-h3 text-h3 font-bold tracking-tighter text-primary dark:text-on-primary-fixed hover:opacity-80 transition-opacity" href="/">
          Shecraa Studio
        </Link>
        <nav className="hidden md:flex gap-8 items-center font-body-md text-body-md">
          {navItems.map((item) => {
            const isActive =
              item.href === "/"
                ? pathname === "/"
                : pathname === item.href || pathname.startsWith(`${item.href}/`);

            return (
              <Link
                key={item.href}
                href={item.href}
                className={
                  isActive
                    ? "font-label-sm text-label-sm uppercase tracking-widest text-primary relative pb-1"
                    : "font-label-sm text-label-sm uppercase tracking-widest text-secondary hover:text-primary transition-colors pb-1"
                }
              >
                {item.label}
                {isActive && (
                  <motion.div
                    layoutId="active-nav-minimal"
                    className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary"
                    transition={{ type: "spring", stiffness: 380, damping: 30 }}
                  />
                )}
              </Link>
            );
          })}
        </nav>
        <Link 
          className="hidden md:inline-flex bg-primary text-on-primary font-label-sm text-label-sm px-6 py-3 rounded uppercase tracking-widest hover:bg-surface-tint transition-all duration-300 hover:scale-105 active:scale-95" 
          href="/contact"
        >
          Let&apos;s Talk
        </Link>
        <MobileMenu />
      </div>
    </header>
  );
}
